import { Textual }	from "@v3/data/textual";
import { HostName }	from "@v3/data/primitive";

// ATTENTION this is always lowercase
// ATTENTION is not disjunct from IpV4!
// ATTENTION this does _not_ allow a dot at the end
export type Fqdn	= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"Fqdn",
		/^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/,
		"must be a lowercase fqdn"
	);

namespace Extension {
	// ATTENTION: this is not just a subtype of string, but lowercases the input!
	export const reallyParse	= (it:string):Fqdn|null => Base.fromString(it.toLowerCase());

	export const prefix	= (hostName:HostName, parent:Fqdn):Fqdn	=>
		Base.brand(`${hostName}.${parent}`);

	export const hostname	= (self:Fqdn):HostName	=> {
		const index	= self.indexOf(".");
		return HostName.brand(index === -1 ? self : self.substring(0, index));
	};

	export const parent	= (self:Fqdn):Fqdn|null	=> {
		const index	= self.indexOf(".");
		return index === -1 ? null : Base.brand(self.substring(index+1));
	};
}

export const Fqdn	= { ...Extension, ...Base };
